module.exports = __webpack_public_path__ + "static/media/titlecard_favedeal@2x.459c2b6f.jpg";